import { render, staticRenderFns } from "./AboutPage.vue?vue&type=template&id=4a00d0dd&scoped=true"
import script from "./AboutPage.vue?vue&type=script&lang=js"
export * from "./AboutPage.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=4a00d0dd&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a00d0dd",
  null
  
)

export default component.exports